import { CatalogProductSchema } from "@redotech/redo-model/catalog/catalog-product-types";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const MarketplaceVariantInput_ = z.object({
  variantId: zExt.objectId(),
  marketplacePrice: z.number().positive(),
  msrp: z.number().positive().optional(),
  minQuantity: z.number().min(0).default(0),
});

export const MarketplaceVariantInput: z.ZodType<MarketplaceVariantInput> =
  MarketplaceVariantInput_;
export interface MarketplaceVariantInput
  extends z.infer<typeof MarketplaceVariantInput_> {}

export const createMarketplaceListing = {
  name: "createMarketplaceListing" as const,
  input: z.object({
    productId: zExt.objectId(),
    brand: z.string().optional(),
    variants: z.array(MarketplaceVariantInput).min(1),
  }),
  output: z.object({ catalogProduct: CatalogProductSchema }),
};
